@if (showParent) {
  <div class="question-panel">
    @if (showHeader) {
      <div class="question-panel__header">
        <div class="question-panel__title">
          {{question?.question_prompt}}
        </div>
        @if (!hidePrem) {
          @if (showHeaderTotal) {
            <div class="question-panel__number">
              @if (processing) {
                <p>Processing...</p>
              }
              @if (!processing) {
                <p><span>{{ questionService?.accounting?.formatMoney(premium) }}</span></p>
              }
            </div>
          }
        }
      </div>
    }
    <div
      class="custom-answer__group form-group mb-0"
      [ngClass]="isPercentage ? 'custom-answer__group--percent' : 'custom-answer__group--value'"
      [id]="uniqueId">
      @for (item of childrenQuestions; track item; let i = $index) {
        <app-question-controller
          [question]="item"
          (questionAnswer)="onChange($event, i)"
          >
        </app-question-controller>
      }
      @if (showFooterTotal) {
        <div class="question-panel__total">
          <div class="question-panel__total-name">
            <p>Total</p>
          </div>
          <div class="question-panel__total-amount">
            @if (isPercentage) {
              <p><span>{{total}}</span> of 100</p>
            }
            @if (!isPercentage) {
              <p><span>{{total | currency:'ZAR':'R ':'1.0-0'}}</span></p>
            }
            @if (isPercentage) {
              <span class="question-panel__total-indi">%</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (!showParent) {
  <div
    class="custom-answer__group form-group mb-0"
    [ngClass]="isPercentage ? 'custom-answer__group--percent' : 'custom-answer__group--value'"
    [id]="uniqueId">
    @for (item of childrenQuestions; track item; let i = $index) {
      <app-question-controller
        [question]="item"
        (questionAnswer)="onChange($event, i)">
      </app-question-controller>
    }
  </div>
}
